import { IToastNotification } from '../interfaces/toast-notification';
import { action, makeObservable, observable } from 'mobx';

class ToastNotificationStore {

  notifications: IToastNotification[] = [];

  constructor() {
    makeObservable(this, {
      notifications: observable,
      addNotification: action,
      updateNotification: action,
      removeNotification: action,
    })
  }

  addNotification = (notification: IToastNotification) => {
    this.notifications.push(notification);
  }

  updateNotification = (notification: IToastNotification) => {
    const index = this.notifications.findIndex(x => x.id === notification.id);
    if (index !== -1) {
      this.notifications[index] = notification;
    }
  }

  removeNotification = (notification: IToastNotification) => {
    const index = this.notifications.findIndex(x => x.id === notification.id);
    if (index !== -1) {
      this.notifications.splice(index, 1);
    }
  }

}

export const toastNotificationStore = new ToastNotificationStore();
